<template>
  <BasicDataEditor
      ref="my-account"
      v-if="user.id"
      data-test-path="user-edit-panel"
      :mode="mode"
      :user-id="user.id"
      :editUser="user"
      :form="form"
      :read-only-inputs="readOnlyInputs"
      @cancel="cancel"
      @ok="save"
      @ok-no-close="saveNoClose"
      @edit-enable="edit"
  >
  </BasicDataEditor>
</template>

<script>
import Activity from "@/activity/Activity";
import DashboardUserForm from "@/components/users/DashboardUserForm";
import ApplicationUser from "@/server/com/silkplm/model/users/ApplicationUser";
import BasicDataEditor from "@/components/users/BasicDataEditor";
import PermissionsSet from "@/server/PermissionsSet";
import FormsLoader from "@/components/forms/FormsLoader";

const FORM_TYPE = ApplicationUser;

export default {
  name: "UserEditPanel",
  permission: () => FormsLoader.formPermission(FORM_TYPE),
  components: {BasicDataEditor},

  async created() {
    this.user = await this.form.editUser(this.mode, this.user.id);
  },


  methods: {
    ...Activity.methods,

    getTitle() {
      return $tr('myProfile','My Profile');
    },

    beforeClose() {
      this.setResult(this.user);
    },

    async canClose() {
      return await DialogManager.canClose(
          this.checkUnsaved && !this.readOnlyInputs,
          this.$refs['my-account'].isValid(),
          () => this.save()
      );
    },

    edit() {
      this.readOnlyInputs = false;
    },

    cancel() {
      this.close();
    },

    openAttachments() {
      this.readOnlyInputs = false;
      this.afterStart(async () => {
        await this.$refs["my-account"].openAttachments();
      });
    },

    async saveNoClose(attachmentLists) {
      await this.save(attachmentLists, false);
    },

    async save(attachmentLists, close=true) {
      try {
        this.form.originalSource.attachments= attachmentLists;
        this.user = await this.form.saveUser();
        if (this.form.password.value.length > 0 && this.form.password2.value.length > 0) {
          await Rpc.Session.signOut();
        }
        this.checkUnsaved = false;
        close && this.close();
      } catch (e) {
        this.form.parseException(e);
        this.edit();
      }
    },
  },

  data: () => ({
    user: new ApplicationUser(),
    form: new DashboardUserForm(),
    mode: "EDIT_AS_USER",
    readOnlyInputs: true,
    autoOpenAttachments: false,
    checkUnsaved: true,
    permissions: new PermissionsSet(),
    FORM_TYPE,
  })

}
</script>
